import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["itemBody", "interactionData"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withI18nSupport } from '@instructure/quiz-common';
import NumericTake from '../../numeric/Take';
import { substituteVars } from '../common/util';

/**
---
category: Formula
---
  Formula Take component

  ```jsx_example
  function Example (props) {
    const exampleProps = {
      itemBody: 'Solve the equation \\(y = `m` \\cdot x + `b`\\) where x = `x`',
      interactionData: {
        variables: [{
          name: 'm',
          value: 2
        }, {
          name: 'b',
          value: 17.23456
        }, {
          name: 'x',
          value: 1000
        }]
      }
    }

    return (
      <FormulaTake {...exampleProps} {...props} />
    )
  }

  <SettingsSwitcher locales={LOCALES}>
    <TakeStateProvider>
      <Example />
    </TakeStateProvider>
  </SettingsSwitcher>
  ```
**/
var FormulaTake = /*#__PURE__*/function (_withI18nSupport) {
  function FormulaTake() {
    _classCallCheck(this, FormulaTake);
    return _callSuper(this, FormulaTake, arguments);
  }
  _inherits(FormulaTake, _withI18nSupport);
  return _createClass(FormulaTake, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        itemBody = _this$props.itemBody,
        interactionData = _this$props.interactionData,
        props = _objectWithoutProperties(_this$props, _excluded);
      var transformedBody = substituteVars(itemBody, interactionData.variables, this.locale);
      return /*#__PURE__*/React.createElement(NumericTake, Object.assign({}, props, {
        itemBody: transformedBody
      }));
    }
  }]);
}(withI18nSupport(Component));
_defineProperty(FormulaTake, "propTypes", {
  itemBody: PropTypes.string.isRequired,
  interactionData: PropTypes.object.isRequired,
  handleResponseUpdate: PropTypes.func.isRequired,
  locale: PropTypes.string
});
_defineProperty(FormulaTake, "defaultProps", {
  locale: null
});
_defineProperty(FormulaTake, "contextTypes", {
  locale: PropTypes.string
});
export { FormulaTake as default };